export class TvaModel {
  constructor(
    public id: number = null,
    public code: string = null,
    public label: string = null
  ) {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
